<div class="property-preview-container">

  <div class="d-flex property-preview-container__header">
    <div class="flex-grow-1 mt-1">
      <span class="ml-2">{{'propertynewPreview.ContentDesign' | translate}}</span>
    </div>
  </div>

  <div class="property-content py-3 px-2">

    <mat-accordion multi="true">
      <ng-container *ngFor="let panel of selectedPropPanels">
        <!-- <mat-expansion-panel [hideToggle]='panel.mapTableData.length === 0' [expanded]="getPanelType(panel.title) === 'Page'"> -->
        <mat-expansion-panel [hideToggle]='panel.mapTableData.size === 0' [expanded]="true">
          <!-- Panel Header -->
          <mat-expansion-panel-header [matTooltip]="'ID : ' + panel.propId" matTooltipPosition="above">
            <mat-panel-title>
              <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                <div class="icon-div d-flex" fxLayoutAlign="center center">
                  <mat-icon *ngIf="getPanelType(panel.title) === 'Page'">crop_portrait_fill</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'Text'">title</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'Line'">remove</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'Image'">image</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'Rectangle'">crop_7_5</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'MeasurementPoint'">table_chart</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'VisualEvents'">photo_album</mat-icon>
                  <i class="fas fa-signature" *ngIf="getPanelType(panel.title) === 'Signature'"></i>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'Summary'">view_list</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'Picture'">view_list</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'DataPlate'">view_list</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'Table'">grid_on</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.title) === 'DropDownList'">list_alt</mat-icon>
                  <div class="title-div">
                    {{ panel.title }}
                  </div>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- Panel Content -->
          <div class="selected-elem-prop-panel" *ngIf="panel.mapTableData.size">
            <div *ngIf="(getPanelType(panel.title) === 'Page')">
              <div *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                <div *ngFor="let metadata of tableData.value">
                  <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                        [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                        [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                  </app-property-editor>
                </div>
              </div>
            </div>
            <div *ngIf="(getPanelType(panel.title) !== 'Page' && getPanelType(panel.title) !== 'Table' && getPanelType(panel.title) !== 'Summary' && getPanelType(panel.title) !== 'Picture'  && getPanelType(panel.title) !== 'DataPlate')">
              <div class="tab-menu" *ngIf="getPanelType(panel.title) !== 'Page'">
                <span (click)="selectedTextTab='Layout'" [ngClass]="{'tab-menu__active-tab': selectedTextTab==='Layout' || !selectedTextTab || !isDisplay(panel)}"><i class="material-icons">design_services</i>{{'propertynewPreview.layout' | translate}}</span>
                <span *ngIf="isDisplay(panel)" (click)="selectedTextTab='DataBinding'" [ngClass]="{'tab-menu__active-tab': selectedTextTab==='DataBinding'}"><i class="material-icons">link</i>{{'propertynewPreview.dataBinding' | translate}}</span>
              </div>
              <div *ngIf="selectedTextTab==='Layout' || !selectedTextTab || !isDisplay(panel)">
                <ng-container *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header [expanded]="true" *ngIf="tableData.key !== undefined">
                      <mat-panel-title>{{ 'objects.' + tableData.key | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngFor="let metadata of tableData.value">
                      <div *ngIf="isLayoutData(metadata, getPanelType(panel.title))">
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                             [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </div>
                    </ng-container>
                  </mat-expansion-panel>
                </ng-container>
              </div>
              <div *ngIf="selectedTextTab==='DataBinding'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                  <div *ngFor="let metadata of tableData.value">
                    <ng-container *ngIf="isDynamicData(metadata, getPanelType(panel.title))">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="getPanelType(panel.title) === 'Table'">
              <div class="tab-menu">
                <span (click)="selectedTableTab='General'" [ngClass]="{'tab-menu__active-tab': selectedTableTab==='General' || !selectedTableTab}">{{'propertynewPreview.general' | translate}}</span>
                <span (click)="selectedTableTab='Table'" [ngClass]="{'tab-menu__active-tab': selectedTableTab==='Table'}">{{'propertynewPreview.table' | translate}}</span>
                <span (click)="selectedTableTab='Columns'" [ngClass]="{'tab-menu__active-tab': selectedTableTab==='Columns'}">{{'propertynewPreview.columns' | translate}}</span>
                <span (click)="selectedTableTab='Rows'" [ngClass]="{'tab-menu__active-tab': selectedTableTab==='Rows'}">{{'propertynewPreview.rows' | translate}}</span>
              </div>
              <div *ngIf="selectedTableTab==='General' || !selectedTableTab">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'GENERAL'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="selectedTableTab==='Table'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'TABLE'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="selectedTableTab==='Columns'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'COLUMN'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="selectedTableTab==='Rows'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'ROW'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div *ngIf="isVisolTable(panel.title)">
              <div class="tab-menu">
                <span *ngIf="isGeneral(panel.propOrElemType)" (click)="selectedVISOLTab='General'" [ngClass]="{'tab-menu__active-tab': selectedVISOLTab==='General' || !selectedVISOLTab || (getPanelType(panel.title) !== 'DataPlate' && selectedVISOLTab==='ImageInfo')}">{{'propertynewPreview.general' | translate}}</span>
                <span *ngIf="isTitle(panel.propOrElemType)" (click)="selectedVISOLTab='Title'" [ngClass]="{'tab-menu__active-tab': (getPanelType(panel.title) === 'DataPlate' && !selectedVISOLTab) || selectedVISOLTab==='Title'}">{{'propertynewPreview.title' | translate}}</span>
                <span *ngIf="isTable(panel.propOrElemType)" (click)="selectedVISOLTab='Table'" [ngClass]="{'tab-menu__active-tab': selectedVISOLTab==='Table'}">{{'propertynewPreview.table' | translate}}</span>
                <span *ngIf="isDataPlate(panel.propOrElemType)" (click)="selectedVISOLTab='ImageInfo'" [ngClass]="{'tab-menu__active-tab': selectedVISOLTab==='ImageInfo'}">{{'propertynewPreview.table' | translate}}</span>
              </div>
              <div *ngIf="activeTab(panel.title, selectedVISOLTab) === 'General'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'GENERAL' && (getPanelType(panel.title) === 'Picture')">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                    <div *ngIf="metadata.category === 'GENERAL' && (getPanelType(panel.title) !== 'Picture')">
                      <span *ngIf="metadata.name === 'defaultPageBreakRowCount'">
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                             [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </span>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="activeTab(panel.title, selectedVISOLTab) === 'Title'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'TITLE'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="activeTab(panel.title, selectedVISOLTab) === 'Table'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'TABLE'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="activeTab(panel.title, selectedVISOLTab) === 'ImageInfo'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'IMAGEINFO'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(tableData.value)" [inputType]="getInputType(tableData.value)" [dynamicId]="getDynamicId(tableData.value)"
                                           [maxLength]="getMaxLength(tableData.value)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </ng-container>

    </mat-accordion>
  </div>
</div>

